(function() {
    'use strict';
    angular.module('aprima-core-ui').directive('apMessageNewNote', [
        function() {
            return {
                restrict: 'E',
                bindToController: true,
                controller: [
                    'ListService',
                    apMessageNewNote
                ],
                controllerAs: 'vm',
                scope: {
                    generalNoteTypeId: '=?',
                    message: '=',
                    newNote: '=',
                },
                templateUrl: '/core-ui/views/directives/apMessageNewNote.html',
            };

            function apMessageNewNote(ListService) {
                /*jshint validthis: true */
                var vm = this;

                vm.generalNotes = [];
                vm.selectedNote = {};

                vm.addHttpError = angular.noop;
                vm.removeHttpError = angular.noop;
                vm.selectedNoteChanged = selectedNoteChanged;

                activate();

                function activate() {
                    if (vm.generalNoteTypeId) {
                        var listsToLoad = {
                            generalNotes: 'generalnotes/' + vm.generalNoteTypeId,
                        };
                        ListService.getLists(listsToLoad, vm);
                    }
                }

                function selectedNoteChanged() {
                    vm.newNote = vm.selectedNote;
                }
            }
        }
    ]);
})();